import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import SearchBarContext, { useLockFocus } from './context';

// top: 0.5 * (navbar height - tick height)
// left: exactly space for magnifying glass icon
// :before:
//   This is a hidden element to measure the width of the company text.
//   Use transparent text color and exact font-size as the input element.
// :after:
//   This is the tick element. Easier to style than html text.
const Tick = styled.span`
  display: flex;
  position: absolute;
  top: ${props => (props.theme.isMobile ? 15 : 23)}px;
  left: ${props => (props.pseudomobile === 'true' ? 20 : 50)}px;
  height: 20px;
  text-transform: uppercase;

  &:before {
    content: "${props => props.company}";
    color: transparent;
    font-size: 14px;
    font-weight: ${props => props.theme.fontWeightHeavy};
    max-width: ${props => props.maxwidth}px;
  }

  &:after {
    content: "${props => props.code}";
    text-align: center;
    vertical-align: middle;
    width: ${props => (props.pseudomobile === 'true' ? 54 : 64)}px;
    margin-left: ${props => (props.pseudomobile === 'true' ? 2 : 5)}px;
    background-color: ${props => props.theme.secondaryColor};
    font-size: 11px;
    line-height: 20px;
    border-radius: 2px;
    color: white;
  }
`;

export default function StockTick() {
  const {
    state: {
      value, pseudoMobile, width,
    },
  } = React.useContext(SearchBarContext);

  const maxWidth = width - (pseudoMobile ? 40 : 146) // original input box width
    - (pseudoMobile ? 20 : 50) // minus left padding
    - ((pseudoMobile ? 54 : 64) + 60); // minus right padding

  return (
    <Tick
      {...useLockFocus()}
      pseudomobile={pseudoMobile.toString()}
      maxwidth={maxWidth}
      company={value}
      code={_.get(window, 'Livewire.request.searchQuery.meta')}
    />
  );
}
